import { isProduction } from './environment'

function getStripeKey () {
  if (isProduction()) {
    return process.env.STRIPE_KEY_PRODUCTION
  }

  return process.env.STRIPE_KEY
}

export { getStripeKey }
